<div class="border-2 border-primary-color border-round border-black p-3 m-auto lg:w-7">
  <div>
    <p class="text-center" style="color: var(--secondary-color);">
      {{noContent}}
    </p>
  </div>
</div>
